import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { ConfirmAccountModel } from '../../../models/account';
import { AccountService } from '../../../services';
import { AppUtils } from '../../../helpers';


@Component({
    selector: 'AccountConfirm',
    templateUrl: './account.confirm.component.html'
})

export class AccountConfirmComponent implements OnInit {
    private model: ConfirmAccountModel = new ConfirmAccountModel();

    constructor(protected vcr: ViewContainerRef,
        private route: ActivatedRoute,
        private router: Router,
        private toastr: ToastsManager,
        private accountService: AccountService,
        private appUtils: AppUtils) {
        this.toastr.setRootViewContainerRef(vcr);
        this.route.queryParams.subscribe(params => {
            this.model.key = params['key'];
            this.model.secret = params['secret'];
        });
    }

    ngOnInit() {
        this.accountService.confirmAccount(this.model)
            .subscribe(
                () => {
                    this.router.navigate(['/account/login']);
                    setTimeout(() => {
                        this.toastr.success('Your account has been verified successfully. Please login to continue.');
                    }, 100);
                },
                error => {
                    this.appUtils.ProcessErrorResponse(this.toastr, error);
                });
    }
}



// WEBPACK FOOTER //
// ./src/components/account/confirm/account.confirm.component.ts